import { ICompetitionCalendarResults, CompetitionCalendarResults } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { CompetitionCalendarAndResultsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CompetitionCalendarAndResultsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<CompetitionCalendarAndResultsQuery>): ICompetitionCalendarResults => {
  return transformer(props);
}

const CompetitionCalendarResultsWidget = ({
  props,
  ...rest
}: WidgetContext<ICompetitionCalendarResults>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CompetitionCalendarResults {...props} />
    </div>
  );
}

export default CompetitionCalendarResultsWidget;